<!----------------------------   Program description   ----------------------------
- Vue Name ID   : goodsOrderSetlePopup
- Vue Name  : 주문결제 팝업
- Author      :
- Create Date : 2021.06.14
- Change History
======================================================================================
 수정일           / 이름 / 사유
======================================================================================
 YYYY.MM.DD  / XYZ / 신규
--------------------------------------------------------------------------------------->


<!-------------------------------------------------------------------------------------
- 1. template
--------------------------------------------------------------------------------------->
<template>
  <div class="layer-content" v-if="showAt">
    <section v-if="stepSe == 'request'">
      <div class="info2">
        결제 정보 확인 후 <span class="pc04">결제하기</span>를 클릭 해주세요.
      </div>
      <div class="balance-sort-wrap mgt20">
        <div class="balance-sort-con box-type04 mgr5"
             style="width: 50%">
          <div class="__in">
            <div class="entry-cho" style="line-height: 24px;">
              <span class="label-txt">주문 정보</span>
            </div>
            <table class="tb-none">
              <colgroup>
                <col style="width:150px;">
                <col style="width:calc( 100% - 150px );">
              </colgroup>
              <tbody>
              <tr>
                <th>주문번호</th>
                <td>{{goodsOrderInfo.orderNo}}</td>
              </tr>
              <tr>
                <th>주문일자</th>
                <td>{{goodsOrderInfo.orderDe}}</td>
              </tr>
              <tr>
                <th>주문상태</th>
                <td>{{goodsOrderInfo.orderSttusNm}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="balance-sort-con box-type04 mgr5"
             style="width: 50%">
          <div class="__in">
            <div class="entry-cho" style="line-height: 24px;">
              <span class="label-txt">주문자 정보</span>
            </div>
            <table class="tb-none">
              <colgroup>
                <col style="width:150px;">
                <col style="width:calc( 100% - 150px );">
              </colgroup>
              <tbody>
              <tr>
                <th>주문자 이름</th>
                <td>{{goodsOrderInfo.mberNm}}</td>
              </tr>
              <tr>
                <th>주문자 이메일</th>
                <td>{{goodsOrderInfo.email}}</td>
              </tr>
              <tr>
                <th>주문자 전화번호</th>
                <td>{{goodsOrderInfo.cttpc}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="balance-sort-wrap mgt20"
           v-if="goodsOrderInfo.dlvyAt == 'Y'">
        <div class="balance-sort-con box-type04">
          <div class="__in">
            <div class="entry-cho" style="line-height: 24px;">
              <span class="label-txt">수령인 및 배송지 정보</span>
              <div class="f-right">
                <button class="small _bt-white"
                        v-if="chkDlvyAdresBtnEnabled"
                        @click="openGoodsOrderDlvyPopup()">
                  <span>배송 정보 변경</span>
                </button>
              </div>
            </div>
            <table class="tb-none">
              <colgroup>
                <col style="width:150px;">
                <col style="width:calc( 100% - 150px );">
              </colgroup>
              <tbody>
              <tr>
                <th>수령인 이름</th>
                <td>{{goodsOrderDlvyInfo.rcverNm}}</td>
              </tr>
              <tr>
                <th>수령인 전화번호</th>
                <td>{{goodsOrderDlvyInfo.cttpc}}</td>
              </tr>
              <tr>
                <th>배송주소</th>
                <td>
                  ( {{goodsOrderDlvyInfo.zip}} ) {{goodsOrderDlvyInfo.bassAdres}} {{goodsOrderDlvyInfo.detailAdres}}
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="balance-sort-wrap mgt20">
        <div class="balance-sort-con box-type04 mgr5">
          <div class="__in">
            <div class="entry-cho">
            <span class="label-txt">주문 상품 정보</span>
          </div>
            <ul class="balance-sort-wrap" style="margin:-5px;flex-wrap:wrap">
              <li class="balance-sort-con"
                  style="padding:5px;box-sizing: border-box;">
                <table class="tb-row">
                  <colgroup>
                    <col style="width:13%;">
                    <col style="width:60%;">
                    <col style="width:27%;">
                  </colgroup>
                  <tbody>
                  <tr v-for="(info,index) in goodsOrderDetailList"
                      :key="'goodsOrderDetail' + index" >
                    <td style="padding: 5px !important;text-align: center;">
                      <img style="border: 1px solid #efefef;width: 40px;height: 40px"
                           v-if="info.fileNo != ''"
                           :src="$onbiLib.getImageFileUrl('', info.fileNm, info.savePath, info.extsn, '')">
                      <img style="border: 1px solid #efefef;width: 40px;height: 40px"
                           v-if="info.fileNo == ''"
                           src="../../../../assets/app/images/common/i5gam-no-img.png">
                    </td>
                    <td>
                      {{ info.goodsNm }}
                      <span class="pdl10 pdr10">( 금액 : {{ $onbiLib.addComma(info.orderAmount) }}원<span class="pdl10 pdr10"> X </span>수량 : {{info.orderQy}} 개 )</span>
                    </td>
                    <td class="txt-center __right"
                        style="font-size: 18px;"
                        v-html="getGoodsOrderAmount(info)">
                    </td>
                  </tr>
                  </tbody>
                </table>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="balance-sort-wrap mgt20"
           v-if="goodsOrderInfo.orderSttusCode != '102'">
        <div class="balance-sort-con box-type04">
          <div class="__in">
            <div class="entry-cho"
                 style="line-height: 24px;">
              <span class="label-txt">결제 정보</span>
            </div>
            <table class="tb-row">
              <colgroup>
                <col style="width:25%;">
                <col style="width:75%;">
              </colgroup>
              <tbody>
              <tr>
                <th class="__left">
                  <span>총 결제 금액<br/>(할인포함)</span>
                </th>
                <td style="font-size: 20px;padding-left: 25px !important;">
                  {{ $onbiLib.addComma(prdctnSetleAmount) }} 원
                </td>
              </tr>
              <tr>
                <th style="text-align: left;">결제 수단</th>
                <td>
                  <template v-for="(info, index) in gopaymethodsList">
                    <input type="radio"
                           :key="'gopaymethods_radio' + index"
                           :id="'gopaymethods' + index"
                           :value="info.value"
                           v-model="gopaymethods">
                    <label style="cursor: pointer;"
                           :key="'gopaymethods_label' + index"
                           :for="'gopaymethods' + index">
                      <span class="box"></span>
                      <span class="label-txt mgr15 mgl5">{{ info.name }}</span>
                    </label>
                  </template>
                </td>
              </tr>
              <tr v-if="gopaymethods != 'Card'">
                <th class="__left">세금계산서 발행 여부</th>
                <td>
                  <input type="checkbox"
                         id="taxbilIsuAt"
                         ref="taxbilIsuAt"
                         true-value="N"
                         false-value="Y"
                         v-model="taxbilIsuAt">
                  <label for="taxbilIsuAt"
                         style="cursor: pointer;">
                    <span class="box"></span>
                    <span class="label-txt">발행</span>
                  </label>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="sv-req-terms-bottom"
           style="padding: 10px 30px;">
        <table class="tb-none">
          <tbody>
          <tr>
            <td style="height: 25px; padding: 0px !important; border-bottom: none;">
              <div>
                <input type="checkbox"
                       id="chkSetleAgreeAt"
                       ref="chkSetleAgreeAt"
                       v-model="chkSetleAgreeAt">
                <label for="chkSetleAgreeAt"
                       style="cursor: pointer;">
                  <span class="box"></span>
                  <span class="label-txt">결제할 상품 내용을 확인하였으며, 구매에 동의합니다. (전자상거래법 제 8조 2항 근거)</span>
                </label>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="btn-wrap t-line center" style="border-top:0;">
      <button class="big _bt-white"
              @click="closePopup()">
        <span>확인</span>
      </button>
      <button class="big _bt-navy"
              @click="orderSetleClick()">
        <span>결제하기</span>
      </button>
    </div>
    </section>
    <section v-if="stepSe == 'finish'">
      <template v-if="inicisResult.code == '000'">
        <div class="sv-req-comp mgb20 mgt20">
          <div class="img-com __icon06"><span>완료 아이콘</span></div>
          <div class="entry-title">
            ** 결제가 완료 되었습니다.<br>
          </div>
          <div class="entry-txt mgt30">
            고객님이 결제하신 주문번호는 <span style="color: red;font-weight: bold;">[ {{goodsOrderInfo.orderNo}} ]</span> 입니다.<br><br>
          </div>
          <div class="entry-txt">
            상세 내용은 <span style="font-weight: bold;">마이페이지 > "추가 주문 내역"</span>에서 확인하실 수 있습니다.
          </div>
        </div>
      </template>
      <template v-if="inicisResult.code != '000'">
        <div class="sv-req-comp">
          <div class="img-com __icon06"><span>완료 아이콘</span></div>
          <div class="entry-title">
            결제에 실패했습니다.<br>
          </div>
          <div class="tit-type6 mgt20">
            다시 결제 시도 후 오류 발생시 고객센터로 연락주시기바랍니다.
          </div>
        </div>
      </template>
    </section>
  </div>
</template>

<!-------------------------------------------------------------------------------------
- 2. Script
--------------------------------------------------------------------------------------->
<script>
/*======================================================================================*
 * 2.1. Import
 *======================================================================================*/
export default {
  /*======================================================================================*
   * 2.2. 뷰 컴포넌트 명칭
   *======================================================================================*/
  nm: 'goodsOrderDtlsPopup',
  props: ['param'],
  /*======================================================================================*
   * 2.3. 지역 변수
   *======================================================================================*/
  data: function () {
    return {
      showAt: false,
      stepSe: 'request',
      chkSetleAgreeAt: false,
      taxbilIsuAt: 'Y',
      goodsOrderInfo:{},
      goodsOrderDetailList:new Array(),
      goodsOrderDlvyInfo:{},
      gopaymethods:'Card',
      gopaymethodsList: [
        { name: '신용카드 결제', value: 'Card' },
        { name: '계좌이체', value: 'DirectBank' },
        { name: '무통장입금', value: 'VBank' }
      ],
      inicisResult: {}
    }
  },
  computed : {
    mberInfo : function(){
      return this.$store.getters.getMberInfo;
    },
    dayInfo: function(){
      return this.$store.getters.getDayInfo;
    },
    chkDlvyAdresBtnEnabled: function(){ //주문완료, 입금대기중, 결제완료인 경우에만 변경 가능
      let showAt = false;
      if(this.goodsOrderInfo.orderSttusCode == '101'
          || this.goodsOrderInfo.orderSttusCode == '201'
          || this.goodsOrderInfo.orderSttusCode == '202'){
        showAt = true;
      }

      return showAt;
    },
    prdctnSetleAmount: function(){
      let amount = 0;

      if(location.host.indexOf('i5gam.gulumma.net') > -1){
        this.goodsOrderDetailList.forEach(function(info){
          amount += (info.orderAmount*info.orderQy)-info.dscntAmount;
        });
      }else{
        amount = 1000;
      }

      return amount;
    },
    inicisSetleParam: function(){
      let merchantData = {
        svcCode: 'SBIW02',
        orderNo: this.goodsOrderInfo.orderNo,
        goodsGroupCode: this.goodsOrderInfo.goodsGroupCode,
        fcltcd: this.goodsOrderInfo.fcltcd,
        mberNo: this.mberInfo.mberNo,
        taxbil: {
          taxbilIsuAt: this.taxbilIsuAt,
          bizrno: this.goodsOrderInfo.bizrno,
          insttNm: this.goodsOrderInfo.fcltNm,
          rprsntv: this.goodsOrderInfo.mberNm,
          adres: this.goodsOrderInfo.adres,
          bizcnd: '',
          item: '',
          taxbilEmail: this.goodsOrderInfo.email,
        },
      };

      return {
        gopaymethods: this.gopaymethods,
        goodsname: this.goodsOrderInfo.goodsGroupNm,
        price: this.prdctnSetleAmount,
        buyername: this.goodsOrderInfo.fcltNm,
        buyertel: this.mberInfo.cttpc,
        buyeremail: this.mberInfo.email,
        merchantData: merchantData,
        finishFunc: this.inicisSetleFinish,
        closeFunc: this.inicisSetlePopupClose,
      }
    },
  },
  /*======================================================================================*
   * 2.3. 함수 (일반 함수, 사용자 정의 함수, 이벤트 함수)
   *======================================================================================*/
  methods: {
    init: function () {
      this.searchGoodsOrderInfo().then(function(){
        const orderSttusCode = this.goodsOrderInfo.orderSttusCode;
        if(this.goodsOrderInfo.orderSttusCode != '101'){
          let msg = '해당 주문은 결제 하실 수 없습니다.';
          if(orderSttusCode == '102'){
            msg += '<br/>※ 사유 : 주문취소 처리 된 주문입니다.';
          }else if(orderSttusCode == '201'||orderSttusCode == '301'||orderSttusCode == '302'){
            msg += '<br/>※ 사유 : 결제가 완료된 주문입니다.';
          }else if(orderSttusCode == '202'){
            msg += '<br/>※ 사유 : 무통장입금 진행중인 주문입니다.';
          }else if(orderSttusCode == '203'){
            msg += '<br/>※ 사유 : 결제취소 된 주문입니다.';
          }
          this.$toasted.show(msg);
          this.closePopup();
        }

        this.showAt = true;
      }.bind(this)).catch(function(){
        this.$toasted.show(this.$onbiLib.msg.err.system);
        this.closePopup();
      }.bind(this));
    },
    searchGoodsOrderInfo: function(){
      return new Promise(function(resolve, reject){
        this.axios.post('/i5gam/goods/searchGoodsOrderInfo.act',{
          orderNo: this.param.orderNo
        }).then(function(response) {
          const goodsInfo = response.data.goodsInfo;

          this.goodsOrderInfo = goodsInfo.goodsOrderInfo;
          this.goodsOrderDetailList = goodsInfo.goodsOrderDetailList;
          this.goodsOrderDlvyInfo   = goodsInfo.goodsOrderDlvyInfo;

          //배송비 존재하는 경우 주문상세에 배송비 정보 넣어줌. goodsNo는 임의로 999로 셋팅함.
          let dlvyAmount = this.goodsOrderInfo.dlvyAmount;
          if(dlvyAmount > 0){
            this.goodsOrderDetailList.push({goodsNo: '999', goodsNm: '배송비', orderAmount: dlvyAmount, orderQy: 1, dscntAmount: 0, fileNo: '',});
          }

          resolve();
        }.bind(this)).catch(function(e) {
          console.log(e);
          this.$toasted.show(this.$onbiLib.msg.err.system);
          reject();
        }.bind(this));
      }.bind(this));
    },
    orderSetleClick: function(){
      if(!this.chkSetleAgreeAt){
        this.$toasted.show('구매동의에 체크해주시기 바랍니다.');
        return false;
      }

      const popupInfo = {
        se:'modalBlank',
        id:'inicisSetlePopup',
        wid:'820',
        hei:'600',
        tit:'이니시스',
        draggableAt:false,
        param: this.inicisSetleParam
      }

      this.$store.commit('openPopup',popupInfo);
    },
    inicisSetleFinish: function(params, popupIndex){
      this.inicisSetlePopupClose(popupIndex);
      this.inicisResult = params;

      if(this.inicisResult.code == '000'){
        this.stepSe = 'finish';

        //마이페이지 리스트 초기화 해줘야함!
        if(typeof this.param.setleCallbackFunc != 'undefined') this.param.setleCallbackFunc();
      }else{
        this.$toasted.show(this.$onbiLib.msg.err.system);
      }
    },
    inicisSetlePopupClose: function(popupIndex){
      this.$store.commit('closePopup', popupIndex);
    },
    openGoodsOrderDlvyPopup: function(){
      const popupInfo = {
        se:'modal',
        id:'goodsOrderDlvyInfoPopup',
        wid:'750',
        hei:'',
        tit:'배송정보 변경',
        draggableAt:false,
        param: {
          orderNo: this.goodsOrderDlvyInfo.orderNo,
          dlvyNo: this.goodsOrderDlvyInfo.dlvyNo,
          rcverNm: this.goodsOrderDlvyInfo.rcverNm,
          cttpc: this.goodsOrderDlvyInfo.cttpc,
          zip: this.goodsOrderDlvyInfo.zip,
          bassAdres: this.goodsOrderDlvyInfo.bassAdres,
          detailAdres: this.goodsOrderDlvyInfo.detailAdres,
          dlvyAmount: this.goodsOrderInfo.dlvyAmount,
          callBackFunc: this.searchGoodsOrderInfo
        }
      };

      this.$store.commit('openPopup',popupInfo);
    },
    getGoodsOrderAmount: function(info){
      let amount = '';

      if(typeof info.dscntAmount == 'undefined' || info.dscntAmount == '') info.dscntAmount = 0;

      if(Number(info.dscntAmount) > 0) {
        amount += '<span style="text-decoration: line-through; color: red; font-size: 15px;">'
        amount += this.$onbiLib.addComma(this.getGoodsSumAmount(info.orderAmount, info.orderQy)) + '원</span><br/>';
      }

      amount += '<span>' + this.$onbiLib.addComma(this.getDscntGoodsAmount(info)) + '원</span>';

      return amount;
    },
    getGoodsSumAmount: function(orderAmount,orderQy){
      return orderAmount * orderQy;
    },
    getDscntGoodsAmount: function(info){
      return (info.orderAmount * info.orderQy) - info.dscntAmount;
    },
    closePopup: function(){
      this.$store.commit('closePopup');
    }
  },
  /*======================================================================================*
   * 2.4. Vue Life Cycle
   *======================================================================================*/
  mounted: function () {
    this.init();
  }
}
</script>